// `navigator.clipboard` needs a secure context; over plain http (the lab server) only execCommand works.
// Returns whether the text reached the clipboard, so callers can tell the user when it did not.
const copyWithExecCommand = text => {
  const area = document.createElement('textarea')
  area.value = text
  area.setAttribute('readonly', '')
  area.style.position = 'fixed'
  area.style.opacity = '0'
  document.body.appendChild(area)
  area.select()
  try {
    return document.execCommand('copy')
  } catch {
    return false
  } finally {
    document.body.removeChild(area)
  }
}

const copyToClipboard = async text => {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // Falls through to the legacy path below.
    }
  }
  return copyWithExecCommand(text)
}

export default copyToClipboard
